import { createFileRoute, redirect } from "@tanstack/react-router";

/* The module's own address had no page and rendered an empty layout. It opens
   on the call log, the first screen on its rail; that route keeps its guard. */
export const Route = createFileRoute("/_authenticated/_front-desk/sarah/")({
  beforeLoad: () => {
    throw redirect({
      to: "/sarah/calls",
      search: {
        tab: undefined,
        q: undefined,
        assignee: undefined,
        residentId: undefined,
        transferredTo: undefined,
        days: undefined,
        from: undefined,
        to: undefined,
        offset: undefined,
      },
      replace: true,
    });
  },
});
